import io from 'socket.io-client'

const state = {
  socket: null,
  listeners: []
}

const getters = {}

const actions = {
  init({ commit }) {
    commit(`CONNECT`)
    commit(`OPEN`)
  },
  listen({ state, commit }, { listener, callback }) {
    if (!state.listeners) state.listeners = []
    if (!state.listeners.includes(listener)) {
      commit(`ON_LISTENER`, listener)
      state.socket.on(listener, callback)
    }
  },
  deafen({ state, commit }, listener) {
    if (!state.listeners?.length) return
    if (state.listeners.includes(listener)) {
      commit(`OFF_LISTENER`, listener)
      state.socket.off(listener)
    }
  }
}

const mutations = {
  CONNECT(state) {
    // eslint-disable-next-line no-undef
    state.socket = io.connect(process.env.VUE_APP_CHAT_API_URL, {
      query: {
        token: localStorage.getItem(`token`)
      }
    })
  },
  ON_LISTENER(state, listener) {
    if (!state.listeners) {
      state.listeners = [listener]
    } else {
      state.listeners.push(listener)
    }
  },
  OFF_LISTENER(state, listener) {
    if (!state.listeners?.length) return
    const index = state.listeners.indexOf(listener)
    if (index >= 0) state.listeners.splice(index, 1)
  },
  OPEN(state) {
    state.socket.open()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
